import React from 'react';
import {Flyout_LogoContainer_FlyoutSection} from '@aboutyou/grpc-clients/tadarida/aysa_api/services/navigation/v1/navigation_bar.types';
import {styled} from '@linaria/react';
import {mediaDesktopAndUp, SectionHeadline} from '@aboutyou/ui-components';
import {LogoSectionItem} from './LogoSectionItem';
import {FLYOUT_CONTENT_MAX_HEIGHT_DESKTOP} from '../../../constants';
import {LogoSectionFooter} from './LogoSectionFooter';
import {css} from '@linaria/core';

export const LogoSection: React.FC<{
  dataTestId: string;
  section: Flyout_LogoContainer_FlyoutSection;
  isCondensedView: boolean;
}> = ({dataTestId, section, isCondensedView}) => {
  const LogoWrapper =
    section.items.length <= 4
      ? LogoSectionItemsWrapper
      : LogoSectionManyItemsWrapper;

  return (
    <Wrapper data-testid={dataTestId}>
      <SectionHeadline label={section.headline} />
      <LogoWrapper className={isCondensedView ? SmallerLogos : NormalSizeLogos}>
        {section.items.map((sectionItem, index) => (
          <LogoSectionItem
            key={`logo_section_item_${sectionItem.brandLogo.slug}`}
            dataTestId={`logoSectionItem_${sectionItem.brandLogo.slug}`}
            sectionItem={sectionItem}
            streamPosition={index}
          />
        ))}
      </LogoWrapper>
      {section.footer && (
        <LogoSectionFooter
          footer={section.footer}
          className={isCondensedView ? CondensedViewFooter : undefined}
        />
      )}
    </Wrapper>
  );
};

const Wrapper = styled.section`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  margin-right: 20px;

  [dir='rtl'] & {
    margin-left: 20px;
    margin-right: unset;
  }
`;

const SmallerLogos = css`
  transform: scale(0.9);
  transform-origin: left;
  flex-wrap: nowrap;
  &&& {
    display: flex;
  }

  [dir='rtl'] & {
    transform-origin: right;
  }

  @media ${mediaDesktopAndUp} {
    &&& {
      display: grid;
    }
    transform: unset;
    transform-origin: unset;
    flex-wrap: wrap;
  }
`;

const NormalSizeLogos = css`
  flex-wrap: wrap;
`;

const CondensedViewFooter = css`
  position: absolute;
  right: 2rem;

  &&& {
    margin-top: 0px;
  }

  [dir='rtl'] & {
    right: unset;
    left: 2rem;
  }

  @media ${mediaDesktopAndUp} {
    position: unset;
    right: unset;
    &&& {
      margin-top: 20px;
    }
  }
`;

const LogoSectionItemsWrapper = styled.div`
  display: grid;
  gap: 10px;
  margin-bottom: 24px;

  grid-auto-flow: column;
  grid-template-rows: repeat(min(2, 2), min-content);

  @media ${mediaDesktopAndUp} {
    margin-bottom: 0;
    max-height: ${FLYOUT_CONTENT_MAX_HEIGHT_DESKTOP}px;
    grid-auto-flow: unset;
    grid-template-rows: repeat(4, 1fr);
    grid-template-columns: 1fr;
  }
`;

const LogoSectionManyItemsWrapper = styled(LogoSectionItemsWrapper)`
  @media ${mediaDesktopAndUp} {
    grid-template-columns: repeat(2, 1fr);
    grid-template-rows: repeat(4, 1fr);
  }
`;
